import { render } from "./searchArea.vue?vue&type=template&id=37a0ddd1"
import script from "./searchArea.vue?vue&type=script&lang=js"
export * from "./searchArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__